import styled, { css } from 'styled-components';
import { Typography } from '../../../../ui/Typography';
import { FlexibleDiv } from '../../../../../styled/common';

export const MapContainer = styled.div<{ isFullScreen: boolean }>`
  height: 140px;
  border-radius: 14px;
  overflow: hidden;
  width: 100%;
  position: relative;
  background-image: url('/static/images/new_ad/icons/map_stub.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

export const MapOverlay = styled.div<{ $isPinSelected?: boolean }>`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: all;
  z-index: 9;

  ${({ $isPinSelected }) =>
    $isPinSelected &&
    css`
      cursor: pointer;
    `}
`;

export const SelectMapButton = styled.button`
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.colors.systemColors.blue};
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding: 10px 15px;
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  height: 40px;
  cursor: pointer;
`;

export const SelectMapButtonText = styled(Typography)`
  color: ${({ theme }) => theme.colors.systemColors.blue};
`;

export const LandmarksContainer = styled(FlexibleDiv)`
  flex-wrap: wrap;
  margin-top: 15px;
  gap: 10px;

  > label {
    margin: 0;
  }
`;

export const chipsStyles = css`
  height: 38px;
  border-radius: 20px;
  padding: 11.5px 15px;
`;
